import React from 'react';

import Input from 'components/Input';
import EditSuperBatchProjectModal from '../EditSuperBatchProjectModal';
import styles from './SbatGroupSuperBatchProject.module.scss';

function SbatGroupSuperBatchProject({ sbatGroup, isEditing, setIsEditing }) {
  const sbatProjects =
    sbatGroup?.super_batch_academy_topics[0]?.active_sbat_projects;
  const superBatchProject = sbatProjects[0]?.super_batch_project;
  const {
    academy_project_id: academyProjectId,
    academy_project: academyProject,
  } = superBatchProject || {};
  const { title } = academyProject;

  return (
    <>
      <EditSuperBatchProjectModal
        isOpen={isEditing}
        setOpen={setIsEditing}
        sbatGroup={sbatGroup}
        superBatchProjectId={superBatchProject?.id}
      />
      <Input
        value={academyProjectId}
        className={styles.input}
        disabled
      />
      <Input
        value={title}
        className={styles.input}
        disabled
      />
    </>
  );
}

export default SbatGroupSuperBatchProject;
